import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate } from "@angular/animations";
import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-multiple-activity-session-popup",
  templateUrl: "./multiple-activity-session-popup.html",
  styleUrls: ["./multiple-activity-session-popup.css"],
  animations: [
    trigger("fadeSlideInOut", [
      state(
        "initial",
        style({
          top: "-450px",
        })
      ),
      state(
        "final",
        style({
          top: "20%",
        })
      ),
      transition("initial <=> final", [animate("1000ms ease-in-out")]),
    ]),
  ],
})
export class MultipleActivitySessionPopup implements OnInit {
  view;
  pageName;
  @Input() show;
  @Input() message;
  @Input() state;
  @Input() warningMessage;
  buttonClicked = false;

  constructor(private router: Router, private route: ActivatedRoute){}
  ngOnInit(): void {
    this.view = this.route.snapshot.params['view'];
    this.pageName = this.route.snapshot.params['page'];

  }

  reloadPage() {
    this.show = "initial";
    location.reload();
  }

  routeToDashboard(){
    if(this.view === 'journey')
    this.router.navigate(["/",this.view,"page",this.pageName]);
    else
    this.router.navigate(["/","page", this.pageName]);
  }
}
